import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProjects = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66663 55C6.66663 43.3333 6.66663 16.6666 6.66663 16.6666H73.3333V66.6666H60H18.3333C18.3333 66.6666 6.66663 66.6666 6.66663 55Z",
			fill: "#90CAF9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 55H25V16.6666H15H6.66663C6.66663 16.6666 6.66663 43.3333 6.66663 55C6.66663 57.4966 7.21996 59.4333 8.05996 60.9766C9.73663 55.025 15 55 15 55Z",
			fill: "#42A5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3333 43.3333H21.6666V6.66663H18.3333C18.3333 6.66663 6.66663 6.66663 6.66663 18.3333C6.66663 28.8383 6.66663 43.2833 6.66663 55C6.66663 43.3333 18.3333 43.3333 18.3333 43.3333Z",
			fill: "#BBDEFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 51.6667H65V55H30V51.6667ZM32.845 47.845L30.4883 45.4883L42.5 33.4767L49.1667 40.1433L57.9883 31.3217L60.345 33.6783L49.1667 44.8567L42.5 38.19L32.845 47.845Z",
			fill: "#1976D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.3334 28.3334L63.3334 38.3334V28.3334H53.3334Z",
			fill: "#1976D2"
		})
	]
});
export default SvgProjects;
